@if (isModalOpen()) {
  <div class="modal-backdrop" (click)="close()">
    <div class="modal-card" (click)="$event.stopPropagation()">
      
      <button class="modal-close" (click)="close()" aria-label="Close Modal">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>

      @if (!isSubmitted()) {
        <div class="modal-header">
          <span class="subtitle">COMMENCE YOUR JOURNEY</span>
          <h2 class="title">BOOK A CONSULTATION</h2>
          <p class="desc">Our architectural leadership team will review your project brief and connect within 24 business hours.</p>
        </div>

        <form [formGroup]="bookingForm" (ngSubmit)="onSubmit()" class="modal-form">
          <div class="form-row">
            <div class="form-field">
              <label>FULL NAME *</label>
              <input type="text" formControlName="fullName" placeholder="e.g. Alexander Vance">
              @if (bookingForm.get('fullName')?.touched && bookingForm.get('fullName')?.invalid) {
                <span class="err">Please enter your full name</span>
              }
            </div>
            
            <div class="form-field">
              <label>EMAIL ADDRESS *</label>
              <input type="email" formControlName="email" placeholder="alexander@domain.com">
              @if (bookingForm.get('email')?.touched && bookingForm.get('email')?.invalid) {
                <span class="err">Please enter a valid email address</span>
              }
            </div>
          </div>

          <div class="form-row">
            <div class="form-field">
              <label>PHONE NUMBER *</label>
              <input type="tel" formControlName="phone" placeholder="0412 345 678">
              @if (bookingForm.get('phone')?.touched && bookingForm.get('phone')?.invalid) {
                <span class="err">Please enter a valid phone number</span>
              }
            </div>

            <div class="form-field">
              <label>PROJECT TYPE *</label>
              <select formControlName="projectType">
                <option value="Custom New Home">Custom New Home</option>
                <option value="Knock Down & Rebuild">Knock Down & Rebuild</option>
                <option value="Duplex Design & Extension">Duplex Design & Extension</option>
              </select>
            </div>
          </div>

          <div class="form-row">
            <div class="form-field">
              <label>PROJECT SUBURB / SITE LOCATION *</label>
              <input type="text" formControlName="suburb" placeholder="e.g. Mosman, NSW">
              @if (bookingForm.get('suburb')?.touched && bookingForm.get('suburb')?.invalid) {
                <span class="err">Please enter project suburb</span>
              }
            </div>

            <div class="form-field">
              <label>ESTIMATED BUDGET</label>
              <select formControlName="budgetRange">
                <option value="$1.5M - $2.5M">$1.5M - $2.5M</option>
                <option value="$2.5M - $4.0M">$2.5M - $4.0M</option>
                <option value="$4.0M - $6.0M">$4.0M - $6.0M</option>
                <option value="$6.0M+">$6.0M+</option>
                <option value="Other">Other</option>
              </select>
            </div>
          </div>

          <div class="form-field full-width">
            <label>TELL US ABOUT YOUR PROJECT VISION</label>
            <textarea formControlName="message" rows="3" placeholder="Block dimensions, special architectural desires, timeline targets..."></textarea>
          </div>

          <button type="submit" [disabled]="isSubmitting()" class="btn-gold submit-btn">
            @if (isSubmitting()) {
              PROCESSING REQUEST...
            } @else {
              CONFIRM CONSULTATION REQUEST
            }
          </button>
        </form>
      } @else {
        <!-- Success State -->
        <div class="success-card">
          <div class="success-icon">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#C5A265" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg>
          </div>

          <h2 class="success-title">CONSULTATION REQUEST RECEIVED</h2>
          <p class="success-desc">
            Thank you, <strong>{{ bookingForm.get('fullName')?.value }}</strong>. Your consultation request has been lodged with our Sydney architectural team.
          </p>

          <div class="reference-box">
            <span class="ref-lbl">YOUR REFERENCE CODE</span>
            <span class="ref-code">{{ referenceCode() }}</span>
          </div>

          <p class="success-sub">A confirmation email has been dispatched. One of our directors will call you on <strong>{{ bookingForm.get('phone')?.value }}</strong> shortly.</p>

          <button (click)="close()" class="btn-gold">
            RETURN TO WEBSITE
          </button>
        </div>
      }

    </div>
  </div>
}
